import { useEffect, useRef, useState } from 'react';
import { styled } from 'styled-components';

export function Splash({ visible }: { visible?: boolean }) {
    const [show, setShow] = useState(!!visible);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        if (visible) {
            setShow(true);
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
        } else {
            timeoutRef.current = setTimeout(() => {
                setShow(false);
            }, 500); // match transition duration
        }
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
        };
    }, [visible]);

    if (!show) return null;
    return (
        <SplashEl visible={visible}>
            <img src="https://app.cloudsaver.com/assets/cloudsaver-loading-2024.gif" alt="Loading..." />
        </SplashEl>
    );
}
export const SplashEl = styled.div<{ visible?: boolean }>`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #fff;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    opacity: ${(p) => (p.visible ? 1 : 0)};
    transition: opacity 0.5s ease;
    pointer-events: ${(p) => (p.visible ? 'auto' : 'none')};
`;
